

function getNodeConfigs (){
    //结构定义 key：类型序号；value：左上竖 左下竖 左横 内容区 右横 右上竖 右下竖
    return {
        "0":"0000000",
        "1":"0011100",
        "2":"0111101",
        "3":"1011110",
        "4":"1111111",
        "5":"1111110",
        "6":"1111101",
        "7":"1011111",
        "8":"0111111",
        "9":"1011100",
        "10":"0111100",
        "11":"0011110",
        "12":"0011101",
        "13":"0010100",
        "14":"1100000",
        "15":"1000000",
        "16":"0001100",
        "17":"0011000",
        "18":"0001111",
        "19":"1111000",
        "20":"0011111",
        "21":"1111100",
        "22":"0010101",
        "23":"0010110",
        "24":"0100000",
        "25":"0111000",
        "26":"1011000"
    }
}


export const utils = {
    getNodeConfigs: getNodeConfigs
}
